import React, { Component } from "react";
import Caption from "../Caption";
import CanvasImage from "./CanvasImage";
import { connect } from "react-redux";
import { getThumbBase64URL } from "../../../../Helpers/Utility";
import PropTypes from "prop-types";

class Image extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSrc: URL.createObjectURL(props.media),
      thumbCanvasId: `${this.props.uniqueId}_media_preview_canvas_thumb`,
      thumbImgDimension:{
        width: 322,
        height: 220
      }
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.imgSrc === nextState.imgSrc && this.props.caption === nextProps.caption ? false : true;
  }

  componentWillUnmount() {
    if (this.state.imgSrc) URL.revokeObjectURL(this.state.imgSrc);
  }

  generateThumb = () => {
    const _this = this;
      const img = document.createElement('img');
      img.src = this.state.imgSrc;
      
      img.onload = () => {
        const canvas = document.getElementById(this.state.thumbCanvasId);
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, this.state.thumbImgDimension.width, this.state.thumbImgDimension.height);
        const image = canvas.toDataURL();
        const thumb = image.replace(/^data:image\/\w+;base64,/, "");
        _this.props.updateMedia(_this.props.media, {
              imageUrl: thumb,
              msgType: "image"
        });
      }
  }

  render() {
    const { media, onChangeCaption, tabIndex, uniqueId, chatType, chatId, selectedFiles } = this.props
    const  { thumbCanvasId, thumbImgDimension:{ width, height} = {}, imgSrc } = this.state
    return (
      <div className="type-image" id={`${uniqueId}_preview`}>
        <canvas id={thumbCanvasId} width={ width } height={ height} style={{display:'none'}}></canvas>
        <CanvasImage uniqueId={uniqueId} imgSrc={imgSrc} generateThumb={this.generateThumb} />
        <Caption
          onChangeCaption={onChangeCaption}
          media={media}
          tabIndex ={ tabIndex }
          uniqueId={ uniqueId}
          chatType={ chatType}
          onClickSend={this.props.onClickSend}
          chatId={chatId}
          selectedFiles={selectedFiles}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    mediaImageThumbData: state.mediaImageThumbData,
  };
};

export default connect(mapStateToProps, {})(Image);

Image.propTypes = {
  media: PropTypes.object,
  updateMedia: PropTypes.func,
  onChangeCaption: PropTypes.func,
  uniqueId: PropTypes.string,
  selectedFiles: PropTypes.array,
  onClickSend: PropTypes.func,
  chatType: PropTypes.string,
  chatId: PropTypes.string,
  type: PropTypes.string,
  mediaImageThumbData: PropTypes.object,
};
